import react, { Component, createRef } from "react";
import Footer from "./footer";
import Header from "./Header";
import ContentLoader from "react-content-loader";
import CryptoJS from "crypto-js";
import Cookies from "js-cookie";
import { connect } from "react-redux";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneInput } from "react-international-phone";
import { PhoneNumberUtil } from "google-libphonenumber";
import Select from "react-select";
import countryList from "react-select-country-list";
import {
  addSettings,
  addMsaInfo,
  setClientLeftMenu,
  setQuotationSettings,
} from "../../actions";

import LefeSideBar from "./leftSideBar";
import Dashboard from "../../Pages/Client/Dashboard";
import Services from "../../Pages/Client/Services";
import Agreements from "../../Pages/Client/Agreements";
import UnsignedAgreements from "../../Pages/Client/Agreements/unsignedagreements";
import UnsignedAgreement from "../../Pages/Client/Agreements/unsigned_single";
import Pdfdownload from "../../Pages/Client/Agreements/pdfdownload";

import Help from "../../Pages/Client/Help";
import CreditApp from "../../Pages/Client/CreditApp";
import AddCreditApp from "../../Pages/Client/CreditApp/addCreditApp";
import ClientboardingDashboard from "../../Pages/Client/Onboarding/OnboardingDashboard";

import MetabaseReports from "../../Pages/Client/MetabaseReports";
import SBCSettings from "../../Pages/Client/SBCSettings";
import RequestReports from "../../Pages/Client/MetabaseReports/requestReport";
import EditRequest from "../../Pages/Client/MetabaseReports/editRequest";
import ViewRequest from "../../Pages/Client/MetabaseReports/viewRequest";
//import ViewClientAnalytics from "../../Pages/Client/MetabaseReports/viewClientAnalytics";

import SubClients from "../../Pages/Client/SubClients";
import AddSubClient from "../../Pages/Client/SubClients/addsubclient";

import AccountActivity from "../../Pages/Client/AccountActivity";
import KycForm from "../../Pages/Client/KycForm";
import Rfqs from "../../Pages/Client/Rfqs";
import AddRfq from "../../Pages/Client/Rfqs/addRfq";
import EditRfq from "../../Pages/Client/Rfqs/editRfq";

import Quotations from "../../Pages/Client/Quotations";
import ViewQuotation from "../../Pages/Client/Quotations/viewQuotation";

import SalesOrders from "../../Pages/Client/SalesOrders";
import ViewSalesOrder from "../../Pages/Client/SalesOrders/viewOrder";
import EditSalesOrder from "../../Pages/Client/SalesOrders/addOrder";

import ClientDocuments from "../../Pages/Client/Documents";

import Forms from "../../Pages/Client/Forms";
import FormSubmit from "../../Pages/Client/Forms/form_submit";
import FormSubmissions from "../../Pages/Client/Forms/form_submissions";
import FormSubmissionSingle from "../../Pages/Client/Forms/form_single_submission";

import BillingInformation from "../../Pages/Client/Billing";
import Invoices from "../../Pages/Client/invoices/index";
import PaymentHistory from "../../Pages/Client/Billing/PaymentHistory";
import Pricing from "../../Pages/Client/Billing/Pricing";

import Loaders from "../../Pages/Client/Loaders";

import Cdr from "../../Pages/Client/Reporting";
import SmsRecords from "../../Pages/Client/Reporting/SmsRecords";
import MouStats from "../../Pages/Client/Reporting/MouStats";
import BalanceUsage from "../../Pages/Client/Reporting/BalanceUsage";

import MSA from "../../Pages/Reseller/MSA";
import DashboardLoader from "../ContentLoaders/dashboard_loader";
import ErrorPage from "../Errors/404";
import AccessDenied from "../Errors/ClientAccessDenied";

import ApiKey from "../../Pages/Client/ApiKey";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";

import {
  getAccountData,
  profileUpdate,
  getRoleFieldSetting,
  clientLeftMenu,
  getQuotationSettings,
  getClientPermissionData,
  getContactAgentDetails,
  get_client_onboarding_user,
  unsignedAgreements,
  verifyFilerID,
  searchFCCFiler,
  checkFilerIdExists,
  getPrivateIntegration,
} from "../../config/client_api_calls";
import FccFilerAutocomplete from "./FccFilerAutocomplete";
import {
  LOGO,
  THEME_COLOR,
  THEME_TEXT_COLOR,
  VENDOR_SIGNATURE,
  APP_LIVE_URL,
  API_URL,
} from "../../config/config";
import { REPLACECONTENT, ValidateEmail, normalize } from "../../config/utility";
import HelperClass from "./../../config/helperClass";
import Agreement from "./agreement_new";

import TextField from "../InputFields/TextField";

import PasswordStrengthBar from "react-password-strength-bar";
import Tooltip from "@material-ui/core/Tooltip";
import LiveKitPopup from "../../components/Client/LiveKitPopup";

import MutextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();

const pageAssociations = {
  CreditApp: ["AddCreditApp"],
  SalesOrders: ["ViewSalesOrder", "EditSalesOrder"],
  Rfqs: ["AddRfq", "EditRfq"],
  Quotations: ["ViewQuotation"],
  SubClients: ["AddSubClient"],
  forms: [
    "client_form_submit",
    "client_form_submissions",
    "client_form_submission_single",
  ],
  MetabaseReports: [
    "requestReports",
    "editRequest",
    "viewRequest",
    "viewClientAnalytics",
  ],
  //Forms: ["forms"]
};

class Main extends Component {
  constructor(props) {
    super(props);

    if (auth.isClientLogin() === false) {
      auth.clientLogout(true);
    }

    this.state = {
      view: this.props.view,
      activePage: "",
      is_msa_signed: false,
      Agreement_Content: "",
      title_agreement: "",
      bgColor: "#ffffff",
      vendor_signor_signature_file: "",
      published_date: "",
      defaultLoader: true,
      errorCompName: "",
      comp_name: "",
      errorName: "",
      name: "",
      errorTitle: "",
      title: "",
      // Role is a separate field from Title, shown only when the reseller
      // has enabled it in custom settings.
      role: "",
      role_field_enabled: false,
      errorEmail: "",
      email: "",
      errorPhone: "",
      phone: "",
      errorPass: "",
      password: "",
      confirm_password: "",
      errorAddress: "",
      address: "",
      errorCity: "",
      city: "",
      errorState: "",
      states: "",
      errorZip: "",
      zip: "",
      errorMessage: "",
      disabled: "",
      successMessage: "",
      routingUrl: "",
      filer_id: "",
      passwordShown: false,
      confirmPasswordShown: false,
      errorAddress2: "",
      address2: "",
      country: "",
      errorCountry: "",
      isLoading: true,
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      leftMenuLoaded: false,

      clientData: [],
      integrationInfo: [],
      parentIntegration: [],
      voicePermissionAdmin: "",

      loginDetails: [],
      errorMessageContactAgent: "",
      successMessageContactAgent: "",
      contact_loader: false,
      contact_subject: "",
      contact_comment: "",
      address_autocomplete: true,
      address_validation: true,
      is_redirect: false,
      direct_sso: false,
      showClientAgentPopup: false,
      conversational_ai_integration: false,
      has_ai_url: false,
      activeAgentId: null,
      activeAccountNo: null,
      activeAgentRoom: null,
      // Onboarding states
      onboardingComplete: true,
      onboardingLoading: true,
      hasPendingMandatoryAgreements: false,
      mandatoryAgreementsStatusLoaded: false,
      has_fcc_filer_id: false,
      is_fcc_enabled: "No",
      fccLoading: false,
      fccSuccess: false,
      fcc_data: null,
      lastVerifiedFilerId: "",
      filerIdAlreadyExists: false,
      errorFilerID: "",
      fcc_filing_url: "",
      isApproved: 0,
      fcc_integration_enabled: false,
      fccAutoFilled: false,
      registrationFieldSettings: {},
    };
    this.phoneInputRef = createRef();
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands",
      )
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
  }

  async componentDidMount() {
    const storedPopup = localStorage.getItem("clientAgentPopupData");
    let showPopup = false;
    let activeAgentId = null;
    let activeAccountNo = null;
    let activeAgentRoom = null;

    if (storedPopup) {
      try {
        const parsed = JSON.parse(storedPopup);
        showPopup = parsed.showPopup === true;
        activeAgentId = parsed.agent_id || null;
        activeAccountNo = parsed.accountno || null;
        activeAgentRoom = parsed.roomName || null;
      } catch (e) {
        localStorage.removeItem("clientAgentPopupData");
      }
    } else if (localStorage.getItem("showClientAgentPopup") === "true") {
      showPopup = true;
    }

    const has_ai_url = !!activeAgentId;

    this.setState({
      showClientAgentPopup: showPopup,
      activeAgentId,
      activeAccountNo,
      has_ai_url,
      isLoading: true,
      activeAgentRoom,
    });

    // Check onboarding and agreement status
    await this.checkOnboardingStatus();
    await this.refreshMandatoryAgreementsStatus();

    const phoneNumber = await auth.getPhoneClient();
    this.setState({
      comp_name:
        auth.getCompNameClient() === false ? "" : auth.getCompNameClient(),
      name: auth.getNameClient() === false ? "" : auth.getNameClient(),
      email: auth.getEmailClient() === false ? "" : auth.getEmailClient(),
      phone: phoneNumber === false ? "" : phoneNumber,
      filer_id: auth.getFilerID() === false ? "" : auth.getFilerID(),
      title: auth.getTitleClient() === false ? "" : auth.getTitleClient(),
    });
    this.defaultChecks();
    this.loadRoleFieldSetting();
    await this.getPrivateIntegrations();
    await this.getLeftMenu();
    await this.getClientPermissionData();
    await this.getQuotationSetting();
    this.setState({ isLoading: false });
    const urlParams = new URLSearchParams(window.location.search);
    const redirect = urlParams.get("redirect");
    const isdirectsso = urlParams.get("directsso");

    if (isdirectsso === "yes") {
      this.setState({
        direct_sso: true,
      });
    }

    if (redirect === "profile") {
      this.setState({
        is_redirect: true,
      });
      window.$("#modalFormProfile").modal("show");
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.onboardingComplete && !prevState.onboardingComplete) {
      this.setState({ mandatoryAgreementsStatusLoaded: false }, () => {
        this.refreshMandatoryAgreementsStatus();
      });
    }

    // Redirect to pending order only after ALL gates are clear:
    // onboarding complete + agreement status loaded + no pending agreements.
    const allGatesClear =
      this.state.onboardingComplete &&
      this.state.mandatoryAgreementsStatusLoaded &&
      !this.state.hasPendingMandatoryAgreements;
    const prevGatesClear =
      prevState.onboardingComplete &&
      prevState.mandatoryAgreementsStatusLoaded &&
      !prevState.hasPendingMandatoryAgreements;

    if (allGatesClear && !prevGatesClear && !this.pendingOrderRedirectHandled) {
      this.pendingOrderRedirectHandled = true;
      this.checkAndHandlePendingOrder();
    }
  }

  checkAndHandlePendingOrder = () => {
    try {
      const pendingOrderRefStr = localStorage.getItem('pendingOrderRef');
      if (pendingOrderRefStr) {
        const pendingOrderRef = JSON.parse(pendingOrderRefStr);
        const TWO_HOURS = 7200000;
        if (pendingOrderRef.service_id && (Date.now() - pendingOrderRef.timestamp) < TWO_HOURS) {
          localStorage.removeItem('pendingOrderRef');
          const base = '/' + auth.getResellerRegToken();
          if (pendingOrderRef.form_accountno && pendingOrderRef.form_accountno !== '') {
            window.location.replace(`${base}/client/client_form_submit/${pendingOrderRef.form_accountno}/${crypto.randomUUID()}/${pendingOrderRef.service_id}`);
            return;
          } else {
            const qty = pendingOrderRef.product_quantity || '1';
            const tempOrderNo = Math.floor(100000 + Math.random() * 900000);
            window.location.replace(`${base}/client/EditSalesOrder/${tempOrderNo}/${pendingOrderRef.service_id}/?qty=${qty}`);
            return;
          }
        }
        localStorage.removeItem('pendingOrderRef');
      }
    } catch (_e) {
      localStorage.removeItem('pendingOrderRef');
    }
  }

  checkOnboardingStatus = async () => {
    try {
      const clientAccountNo = auth.getClientAccount();

      // Fetch onboarding status from API for client
      const response = await get_client_onboarding_user(clientAccountNo);

      // console.log("📋 Onboarding API Response:", response);

      if (response && response.data && response.data.status === "success") {
        const onboardingData = response.data.data;

        // If no steps exist or user doesn't have onboarding, allow access to dashboard
        if (!onboardingData || !onboardingData.status) {
          // console.log(
          //   "ℹ️ No onboarding steps found for this user. Allowing dashboard access."
          // );
          this.setState({
            onboardingComplete: true,
            onboardingLoading: false,
          });
          return;
        }

        // Check if status is "complete" or "incomplete"
        let isOnboardingComplete = onboardingData.status === "complete";

        // If status is not complete, check if all steps are either filled or skipped
        if (!isOnboardingComplete) {
          // Handle both response.data.steps and response.data.steps.steps structures
          const stepsArray =
            onboardingData.steps?.steps || onboardingData.steps;
          if (
            stepsArray &&
            Array.isArray(stepsArray) &&
            stepsArray.length > 0
          ) {
            isOnboardingComplete = stepsArray.every(
              (step) => step.isFilled === 1 || step.isSkipped === 1,
            );
          }
        }

        this.setState({
          onboardingComplete: isOnboardingComplete,
          onboardingLoading: false,
        });

        // console.log(
        //   "Client Onboarding Status:",
        //   isOnboardingComplete ? "Completed ✓" : "Incomplete - Show Stepper"
        // );
      } else {
        // If API call fails (404, 500, etc), allow access to dashboard
        // User might not have onboarding configured
        
        this.setState({
          onboardingComplete: true,
          onboardingLoading: false,
        });
      }
    } catch (error) {
      console.error("❌ Error checking onboarding status:", error);
      // Allow access to dashboard if onboarding check fails
      this.setState({
        onboardingComplete: true,
        onboardingLoading: false,
      });
    }
  };

  refreshMandatoryAgreementsStatus = async () => {
    try {
      const response = await unsignedAgreements(
        auth.getClientAccount(),
        auth.getClientToken(),
        "required",
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
        return;
      }

      const hasPendingMandatoryAgreements =
        response.data.status === 200 &&
        Array.isArray(response.data.data) &&
        response.data.data.length > 0;

      this.setState({
        hasPendingMandatoryAgreements,
        mandatoryAgreementsStatusLoaded: true,
      });
    } catch (error) {
      console.error("Error checking mandatory agreements:", error);
      this.setState({
        hasPendingMandatoryAgreements: false,
        mandatoryAgreementsStatusLoaded: true,
      });
    }
  };

  getClientPermissionData = async () => {
    let acctno = auth.getClientAccount();

    let res = await getClientPermissionData(
      acctno,
      auth.getClientToken(),
      auth.getEmailClient(),
    );
    // console.log("getClientPermissionData: ", res.data);
    if (res.data.status === 200 && res.data.message === "success") {
      const permissionData = res.data.clientPermissionSettingsInfo?.data || {};
      const integrationInfo =
        res.data.clientPermissionSettingsInfo?.integrationInfo?.[0] || null;
      const aiUrlInfo = res.data.ai_url_info || [];
      const isConversationalAIEnabled =
        integrationInfo &&
        integrationInfo.active === 1 &&
        integrationInfo.enabled?.toLowerCase() === "yes";
      const hasActiveAgent =
        Array.isArray(aiUrlInfo) &&
        aiUrlInfo.some(
          (agent) => agent.agent_id && agent.agent_id.trim() !== "",
        );
      this.setState({
        clientData: res.data.clientData,
        // Role is a separate field from Title; this response carries the full
        // client row, so prefill the profile form from it as well.
        role:
          (res.data.clientData &&
            res.data.clientData[0] &&
            res.data.clientData[0].role) ||
          this.state.role ||
          "",
        integrationInfo: res.data.integrationInfo,
        parentIntegration: res.data.parentIntegration,
        voicePermissionAdmin: res.data.voicePermissionAdmin,
        address_autocomplete: permissionData.address_autocomplete,
        address_validation: permissionData.address_validation,
        conversational_ai_integration: isConversationalAIEnabled,
        has_ai_url: hasActiveAgent,
        registrationFieldSettings: res.data.registration_fields || {},
      });
    }
  };

  loginDetailView = () => {
    this.setState({ successMessage: "", errorMessage: "" });
    window.$("#modalLoginDetail").modal("show");
  };

  getLeftMenu = async () => {
    let acctno = auth.getClientAccount();

    try {
      let res = await clientLeftMenu(
        acctno,
        auth.getClientToken(),
        auth.getEmailClient(),
      );
      //console.log("getClientLeftMenu: ", res.data);
      if (
        res.data.status === 200 &&
        res.data.message === "success" &&
        res.data.data.length > 0
      ) {
        // Dispatch action to update left menu in Redux
        this.props.setClientLeftMenu(res.data.data);
        this.setState({ loginDetails: res.data.loginDetails });
      }
    } finally {
      this.setState({ leftMenuLoaded: true });
    }
  };

  getQuotationSetting = async () => {
    let acctno = auth.getClientAccount();

    let res = await getQuotationSettings(
      acctno,
      auth.getClientToken(),
      auth.getEmailClient(),
    );
    //console.log("getQuotationSettings: ", res.data);
    if (
      res.data.status === 200 &&
      res.data.message === "success" &&
      res.data.data.length > 0
    ) {
      // Dispatch action to update left menu in Redux
      this.props.setQuotationSettings(res.data.data);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone),
      );
    } catch (error) {
      return false;
    }
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description,
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`,
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        // console.log("addressComponents", addressComponents);
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";

        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });

        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }

        this.setState({
          city: city && city !== "" ? city : "",
          states: state && state !== "" ? state : "",
          zip: zipCode && zipCode !== "" ? zipCode : "",
          country: country && country !== "" ? country : "",
          address: streetAddress && streetAddress !== "" ? streetAddress : "",
          address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleChangeCountry = (event) => {
    // console.log("event.label: ", event.label);
    const country = event.label;
    this.setState({
      country: country,
    });
  };

  isFieldRequired = (fieldKey) => {
    const { registrationFieldSettings } = this.state;
    // If registration_fields doesn't exist or is empty, default to required
    if (
      !registrationFieldSettings ||
      Object.keys(registrationFieldSettings).length === 0
    ) {
      return true;
    }
    // If field is explicitly set to "optional", return false, otherwise required
    return registrationFieldSettings[fieldKey] !== "optional";
  };

  formUpdate = async () => {
    let {
      name,
      email,
      comp_name,
      title,
      phone,
      address,
      city,
      states,
      zip,
      password,
      confirm_password,
      is_msa_signed,
      address2,
      country,
      filer_id,
      has_fcc_filer_id,
      fcc_integration_enabled,
    } = this.state;
    const modalBody = document.getElementById("modalFormProfile");
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (modalBody) {
      setTimeout(() => {
        modalBody.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 0);
    }

    let is_validated = true;

    // FCC 499 Validation
    if (fcc_integration_enabled && has_fcc_filer_id) {
      if (filer_id === "" || filer_id.trim() === "") {
        this.setState({
          errorFilerID: "Filer ID is required when checkbox is checked.",
          errorMessage: "Filer ID is required.",
        });
        is_validated = false;
      } else if (filer_id.trim().length < 6) {
        this.setState({
          errorFilerID: "Filer ID must be at least 6 digits.",
          errorMessage: "Filer ID must be at least 6 digits.",
        });
        is_validated = false;
      } else if (!this.state.fccSuccess) {
        this.setState({
          errorFilerID: "Please verify the Filer ID before saving.",
          errorMessage: "Please verify the Filer ID before saving.",
        });
        is_validated = false;
      } else if (this.state.filerIdAlreadyExists) {
        this.setState({
          errorFilerID: "This Filer ID is already associated with an existing client.",
          errorMessage: "This Filer ID is already associated with an existing client.",
        });
        is_validated = false;
      }
    }

    if (this.isFieldRequired("client_company") && comp_name === "") {
      this.setState({
        errorCompName: "error",
        errorMessage: "Company Name is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("name") && name === "") {
      this.setState({
        errorCompName: "",
        errorName: "error",
        errorMessage: "Full Name is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("client_phone") && phone === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (
      this.isFieldRequired("client_phone") &&
      phone !== "" &&
      !this.isPhoneValid(phone)
    ) {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "error",
        errorMessage: "Invalid phone format.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("client_address") && address === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("client_city") && city === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("client_state") && states === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("client_zip") && zip === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "error",
        errorMessage: "Zip is required.",
      });
      is_validated = false;
    } else if (this.isFieldRequired("client_country") && country === "") {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorPhone: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "",
        errorCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(email) === false) {
      this.setState({
        errorEmail: "error",
        errorName: "",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (password !== "") {
      if (password.length < 8) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (!passwordRegex.test(password)) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (confirm_password === "") {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (confirm_password.length < 8) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (password.trim() != confirm_password.trim()) {
        this.setState({
          errorCompName: "",
          errorName: "",
          errorPhone: "",
          errorAddress: "",
          errorCity: "",
          errorState: "",
          errorZip: "",
          errorCountry: "",
          errorPass: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    if (is_validated) {
      this.setState({
        errorCompName: "",
        errorName: "",
        errorAddress: "",
        errorCity: "",
        errorState: "",
        errorZip: "",
        errorCountry: "",
        errorPass: "",
        errorEmail: "",
        errorMessage: "",
        errorConfirm: "",
        errorPhone: "",
        errorTitle: "",
        disabled: true,
      });

      let apiResponce = await profileUpdate(
        auth.getClientAccount(),
        auth.getClientToken(),
        name,
        title,
        comp_name,
        phone,
        address,
        city,
        states,
        zip,
        password,
        address2,
        country,
        has_fcc_filer_id ? filer_id : "",
        has_fcc_filer_id && this.state.fcc_data ? this.state.fcc_data : null,
        // Only send role when the field is enabled so it is never wiped.
        this.state.role_field_enabled ? this.state.role : undefined,
      );
      //console.log(apiResponce);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } /*else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        this.setState({
          errorMessage:
            "Address validation failed. Check if zip, state, city, and country are correctly matched.",
          disabled: false,
        });
      }*/ else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          disabled: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        await this.getClientPermissionData();
        Cookies.set(
          "client_comp_nme__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["comp_name"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_name__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["name"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_phone__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["phone"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );
        Cookies.set(
          "client_title__",
          CryptoJS.AES.encrypt(
            apiResponce.data.data[0]["title"],
            process.env.REACT_APP_SIGNATURE,
          ).toString(),
        );

        this.setState({
          successMessage: "Profile updated successfully.",
          disabled: false,
        });
        if (is_msa_signed === false) {
          window.location.reload();
        }
        /*setTimeout(async function () {
          window.$("#modalFormProfile").modal("hide");
        }, 2000);*/

        setTimeout(
          async function () {
            const { integrationInfo, voicePermissionAdmin, parentIntegration } =
              this.state;
            const userType = auth.getUserTypeClient();

            let shouldRedirect = false;

            if (userType === "Super") {
              // For Super users, check the integrationInfo as before
              if (voicePermissionAdmin === "Yes") {
                if (integrationInfo && integrationInfo.length > 0) {
                  if (integrationInfo[0]["enable"] === "Yes") {
                    shouldRedirect = true;
                  }
                }
              }
            } else if (userType === "Sub") {
              // For Sub users, check both integrationInfo and parentIntegration
              if (voicePermissionAdmin === "Yes") {
                if (
                  integrationInfo &&
                  integrationInfo.length > 0 &&
                  parentIntegration &&
                  parentIntegration.length > 0
                ) {
                  if (
                    integrationInfo[0]["enable"] === "Yes" &&
                    parentIntegration[0]["enable"] === "Yes"
                  ) {
                    shouldRedirect = true;
                  }
                }
              }
            }
            window.$("#modalFormProfile").modal("hide");
            if (shouldRedirect) {
              this.handleRedirect();
            } else {
              if (auth.getVAReturnUrl() && auth.getVAReturnUrl() !== "") {
                window.$("#modalAlertPermission").modal("show");
              }

              // console.log(
              //   "Redirect condition not met, staying on the current page."
              // );
            }
          }.bind(this),
          2000,
        );
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try later.",
          disabled: false,
        });
        return false;
      } else {
        auth.clientLogout();
      }
    }
  };

  contactAgent = async () => {
    this.setState({
      successMessageContactAgent: "",
      errorMessageContactAgent: "",
      contact_loader: true,
      contact_subject: "",
      contact_comment: "",
    });
    window.$("#modalContactAgent").modal("show");
    let apiResponce = await getContactAgentDetails(
      auth.getClientAccount(),
      auth.getClientToken(),
    );
    if (
      apiResponce.data.status === 403 ||
      apiResponce.data.errors === "authentication missing" ||
      apiResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (
      apiResponce.data.status === 200 &&
      apiResponce.data.message === "success"
    ) {
      this.setState({
        successMessageContactAgent: "",
        errorMessageContactAgent: "",
        contact_loader: false,
        contact_subject: "",
        contact_comment: "",
      });
    } else {
      this.setState({
        successMessageContactAgent: "",
        errorMessageContactAgent: "",
        contact_loader: false,
        contact_subject: "",
        contact_comment: "",
      });
    }
  };

  contactAgentSubmit = async () => {
    const { contact_subject, contact_comment } = this.state;
  };

  pythonEncrypt = (data, passphrase) => {
    const secretKey = CryptoJS.enc.Hex.parse(passphrase);
    const iv = CryptoJS.lib.WordArray.random(16);

    const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    // Concatenate raw IV + ciphertext (in binary form)
    const rawIv = iv;
    const rawCiphertext = CryptoJS.enc.Base64.parse(encrypted.toString());

    const combined = rawIv.concat(rawCiphertext);

    const base64Encoded = CryptoJS.enc.Base64.stringify(combined);

    return base64Encoded
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  // pythonEncrypt = (data, passphrase) => {
  //   const secretKey = CryptoJS.enc.Hex.parse(passphrase);
  //   const iv = CryptoJS.lib.WordArray.random(16);

  //   const encrypted = CryptoJS.AES.encrypt(data, secretKey, {
  //     iv: iv,
  //     mode: CryptoJS.mode.CBC,
  //     padding: CryptoJS.pad.Pkcs7,
  //   });

  //   const json = {
  //     iv: CryptoJS.enc.Base64.stringify(iv),
  //     data: encrypted.toString(),
  //   };

  //   const base64Encoded = CryptoJS.enc.Base64.stringify(
  //     CryptoJS.enc.Utf8.parse(JSON.stringify(json))
  //   );

  //   // URL-safe Base64 encoding
  //   return base64Encoded
  //     .replace(/\+/g, "-")
  //     .replace(/\//g, "_")
  //     .replace(/=+$/, "");
  // };

  handleRedirect = () => {
    // console.log("clientData", this.state.clientData);

    let accountno = auth.getClientAccount();
    let parent_accountno = auth.getParentAcctClient();
    let email = auth.getEmailClient();
    let firstName = auth.getNameClient() === false ? "" : auth.getNameClient();
    let compName =
      auth.getCompNameClient() === false ? "" : auth.getCompNameClient();
    let userType = auth.getUserTypeClient();
    let address =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].address;
    let title =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].title;
    let phone =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].phone;
    let country =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].country;
    let city =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].city;
    let zip =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].zip;
    let state =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].state;
    let account_status =
      this.state.clientData &&
      this.state.clientData.length > 0 &&
      this.state.clientData[0].account_status;

    let ocn =
      this.state.integrationInfo &&
        this.state.integrationInfo.length > 0 &&
        this.state.integrationInfo[0].ocn
        ? this.state.integrationInfo[0].ocn
        : "";
    let return_url = APP_LIVE_URL + auth.getResellerRegToken() + "/client";

    let status = account_status === "active" ? 1 : 0;

    let tokenData = {
      accountno,
      email,
      firstName,
      compName,
      userType,
      status,
      title,
      phone,
      address,
      city,
      state,
      zip,
      country,
      ocn,
      return_url,
      isDirectSSO: this.state.direct_sso,
    };

    if (userType === "Sub") {
      tokenData.parent_accountno = parent_accountno;
    }

    const tokenDataString = JSON.stringify(tokenData);

    const secretKey = process.env.REACT_APP_CARRIER_VOICE_ALERTS_SECRET_KEY;
    const encryptedToken = this.pythonEncrypt(tokenDataString, secretKey);
    const baseUrl = process.env.REACT_APP_CARRIER_VOICE_ALERTS_URL_PROFILE;
    const url = `${encryptedToken}`;
    if (auth.getVAReturnUrl() && auth.getVAReturnUrl() !== "") {
      window.location.replace(`${baseUrl}${url}`);
    }
  };

  modalHideRemoveAlert = (modal_id) => {
    window.$("#" + modal_id).modal("hide");
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  // Autocomplete search API wrapper for authenticated client
  searchFCCFilerClient = async (query) => {
    try {
      const response = await searchFCCFiler(
        auth.getClientAccount(),
        auth.getClientToken(),
        query,
      );
      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      }
      return response;
    } catch (error) {
      console.error("FCC search error:", error);
      return { data: { status: "error", data: [] } };
    }
  };

  handleFilerIdInputChange = (value) => {
    const filerId = value;

    if (
      filerId.trim() === this.state.lastVerifiedFilerId &&
      this.state.lastVerifiedFilerId !== ""
    ) {
      this.setState({ filer_id: filerId, errorFilerID: "", fccSuccess: true });
      return;
    }

    this.setState({
      filer_id: filerId,
      errorFilerID: "",
      fccSuccess: false,
      isApproved: 0,
    });
  };

  /**
   * Normalize FCC phone numbers: prepend US country code (1) for 10-digit numbers.
   * FCC is US-only; numbers sometimes arrive without country code (e.g. 832-506-0905).
   * This prevents the phone input from misdetecting the country.
   */
  normalizeFccPhone = (phone) => {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    if (digits.length === 10) {
      return `+1${digits}`;
    }
    if (digits.length === 11 && digits.startsWith("1")) {
      return `+${digits}`;
    }
    return phone;
  };

  /**
   * Safe autofill: only populate fields that are currently empty.
   * Never overwrite user-entered or already-saved values.
   */
  safeAutoFillFromFCC = (fccData) => {
    if (!fccData || !fccData.robocall_data) return;

    const robocallData = fccData.robocall_data;
    const updates = {};
    let didAutoFill = false;

    const safeSet = (stateKey, fccValue) => {
      const current = this.state[stateKey];
      let isEmpty = current === "" || current === null || current === undefined;
      // For phone, also treat bare dial codes (e.g. "+1") as empty
      if (stateKey === "phone" && !isEmpty && current) {
        const phoneDigits = String(current).replace(/\D/g, "");
        if (phoneDigits.length <= 3) isEmpty = true;
      }
      if (isEmpty && fccValue && String(fccValue).trim() !== "") {
        updates[stateKey] = fccValue;
        didAutoFill = true;
      }
    };

    safeSet("comp_name", robocallData.business_name);
    safeSet("name", robocallData.robocall_mitigation_contact_name);
    safeSet("title", robocallData.contact_title);
    safeSet(
      "phone",
      this.normalizeFccPhone(robocallData.contact_telephone_number),
    );
    safeSet("email", robocallData.contact_email);
    safeSet("address", robocallData.business_address || robocallData.address);
    safeSet("city", robocallData.city);
    safeSet("states", robocallData.state);
    safeSet("zip", robocallData.zip);
    safeSet("country", robocallData.country);

    if (Object.keys(updates).length > 0) {
      updates.fccAutoFilled = true;
      this.setState(updates);

      // Auto-hide the autofill badge after 5 seconds
      setTimeout(() => {
        this.setState({ fccAutoFilled: false });
      }, 5000);
    }
  };

  handleFilerIdSelect = async (item) => {
    const filerId = item.filer_id;
    this.setState({
      filer_id: filerId,
      errorFilerID: "",
      fccLoading: true,
      fccSuccess: false,
      isApproved: 0,
    });

    try {
      const response = await verifyFilerID(
        auth.getClientAccount(),
        auth.getClientToken(),
        filerId,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (response.data.status === 200) {
        const fccData = response.data.frn_details?.data || response.data.data;
        this.setState({
          fccLoading: false,
          fcc_data: fccData,
          lastVerifiedFilerId: filerId,
          errorFilerID: "",
        });

        // Check if Filer ID already exists (AWAIT this check)
        try {
          const checkResponse = await checkFilerIdExists(
            auth.getClientAccount(),
            auth.getClientToken(),
            filerId
          );
          
          if (checkResponse.data && checkResponse.data.exists) {
            this.setState({
              filerIdAlreadyExists: true,
              errorFilerID: "This Filer ID is already associated with an existing client.",
              fccSuccess: false,
            });
            return; // Exit early
          } else {
            this.setState({
              filerIdAlreadyExists: false,
              fccSuccess: true,
            });
          }
        } catch (error) {
          console.error("Error checking filer ID:", error);
          this.setState({
            filerIdAlreadyExists: false,
            fccSuccess: true,
          });
        }

        // Safe autofill: only fill empty fields
        this.safeAutoFillFromFCC(fccData);
      } else {
        let errorMsg = "Failed to verify Filer ID";
        if (response.data.errors) {
          if (typeof response.data.errors === "string") {
            errorMsg = response.data.errors;
          } else if (
            typeof response.data.errors === "object" &&
            response.data.errors.message
          ) {
            errorMsg = response.data.errors.message;
          }
        }
        this.setState({
          fccLoading: false,
          errorFilerID: errorMsg,
          fccSuccess: false,
        });
      }
    } catch (error) {
      console.error("Error verifying Filer ID:", error);
      this.setState({
        fccLoading: false,
        errorFilerID: "An error occurred while verifying Filer ID",
        fccSuccess: false,
      });
    }
  };

  handleFilerIdChange = async (event) => {
    const filerId = event.target.value;

    // Show success message if this Filer ID has already been verified
    if (
      filerId.trim() === this.state.lastVerifiedFilerId &&
      this.state.lastVerifiedFilerId !== ""
    ) {
      this.setState({ filer_id: filerId, errorFilerID: "", fccSuccess: true });
      return;
    }
    // Reset isApproved to 0 when a new filer id is entered
    this.setState({
      filer_id: filerId,
      errorFilerID: "",
      fccSuccess: false,
      isApproved: 0,
    });

    // Only trigger API when exactly 6 digits are entered
    if (filerId.trim().length === 6 && !this.state.fccLoading) {
      this.setState({ fccLoading: true });
      try {
        const response = await verifyFilerID(
          auth.getClientAccount(),
          auth.getClientToken(),
          filerId,
        );

        if (
          response.data.status === 403 ||
          response.data.errors === "authentication missing" ||
          response.data.errors === "jwt expired"
        ) {
          auth.clientLogout();
        } else if (response.data.status === 200) {
          const fccData = response.data.frn_details?.data || response.data.data;

          this.setState({
            fccLoading: false,
            fcc_data: fccData,
            lastVerifiedFilerId: filerId,
            errorFilerID: "",
          });

          // Check if Filer ID already exists (AWAIT this check)
          try {
            const checkResponse = await checkFilerIdExists(
              auth.getClientAccount(),
              auth.getClientToken(),
              filerId
            );
            
            if (checkResponse.data && checkResponse.data.exists) {
              this.setState({
                filerIdAlreadyExists: true,
                errorFilerID: "This Filer ID is already associated with an existing client",
                fccSuccess: false,
              });
              return; // Exit early
            } else {
              this.setState({
                filerIdAlreadyExists: false,
                fccSuccess: true,
              });
            }
          } catch (error) {
            console.error("Error checking filer ID:", error);
            this.setState({
              filerIdAlreadyExists: false,
              fccSuccess: true,
            });
          }

          // Safe autofill: only fill empty fields
          this.safeAutoFillFromFCC(fccData);
        } else {
          let errorMsg = "Failed to verify Filer ID";
          if (response.data.errors) {
            if (typeof response.data.errors === "string") {
              errorMsg = response.data.errors;
            } else if (
              typeof response.data.errors === "object" &&
              response.data.errors.message
            ) {
              errorMsg = response.data.errors.message;
            }
          }
          this.setState({
            fccLoading: false,
            errorFilerID: errorMsg,
            fccSuccess: false,
          });
        }
      } catch (error) {
        console.error("Error verifying Filer ID:", error);
        this.setState({
          fccLoading: false,
          errorFilerID: "An error occurred while verifying Filer ID",
          fccSuccess: false,
        });
      }
    }
  };

  handleFilerIdBlur = async () => {
    const filerId = this.state.filer_id.trim();

    if (filerId === "") {
      this.setState({
        errorFilerID: "",
        fccSuccess: false,
      });
      return;
    }

    // Check if this Filer ID has already been verified or if API is currently loading
    if (filerId === this.state.lastVerifiedFilerId || this.state.fccLoading) {
      return;
    }

    this.setState({ fccLoading: true, isApproved: 0 });
    try {
      const response = await verifyFilerID(
        auth.getClientAccount(),
        auth.getClientToken(),
        filerId,
      );

      if (
        response.data.status === 403 ||
        response.data.errors === "authentication missing" ||
        response.data.errors === "jwt expired"
      ) {
        auth.clientLogout();
      } else if (response.data.status === 200) {
        const fccData = response.data.frn_details?.data || response.data.data;

        this.setState({
          fccLoading: false,
          fcc_data: fccData,
          lastVerifiedFilerId: filerId,
          errorFilerID: "",
        });

        // Check if Filer ID already exists (AWAIT this check)
        try {
          const checkResponse = await checkFilerIdExists(
            auth.getClientAccount(),
            auth.getClientToken(),
            filerId
          );
          
          if (checkResponse.data && checkResponse.data.exists) {
            this.setState({
              filerIdAlreadyExists: true,
              errorFilerID: "This Filer ID is already associated with an existing client",
              fccSuccess: false,
            });
            return; // Exit early
          } else {
            this.setState({
              filerIdAlreadyExists: false,
              fccSuccess: true,
            });
          }
        } catch (error) {
          console.error("Error checking filer ID:", error);
          this.setState({
            filerIdAlreadyExists: false,
            fccSuccess: true,
          });
        }

        // Safe autofill: only fill empty fields
        this.safeAutoFillFromFCC(fccData);
      } else {
        this.setState({
          fccLoading: false,
          errorFilerID: response.data.errors || "Failed to verify Filer ID",
          fccSuccess: false,
        });
      }
    } catch (error) {
      console.error("Error verifying Filer ID:", error);
      this.setState({
        fccLoading: false,
        errorFilerID: "An error occurred while verifying Filer ID",
        fccSuccess: false,
      });
    }
  };

  handleFilerIdKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handleFilerIdBlur();
    }
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "comp_name") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }
    if (name === "filer_id") {
      this.setState({
        [name]: value,
        isApproved: 0, // Hide approved badge when filer_id changes
      });
    } else {
      this.setState({
        [name]: value,
      });
    }
  };

  agreementSigned = () => {
    this.setState({ is_msa_signed: true });
  };

  getPrivateIntegrations = async () => {
    try {
      const getIntegrations_res = await getPrivateIntegration(
        auth.getClientAccount(),
        auth.getClientToken(),
      );

      if (getIntegrations_res.data.status === 200) {
        const clientInfo = getIntegrations_res.data.clientInfo || [];
        const integrations = getIntegrations_res.data.data || [];

        // Check if FCC 499 integration is enabled
        const fccIntegration = integrations.find(
          (integration) =>
            integration.integration_title === "FCC 499" &&
            integration.active === 1 &&
            integration.enabled === "Yes" &&
            integration.is_enabled_on_registration === 1,
        );

        if (fccIntegration && clientInfo.length > 0) {
          const client = clientInfo[0];
          const hasFilerIdFromDB =
            client.fcc_filer_id && client.fcc_filer_id !== "";
          // Only set isApproved from DB (admin approval)
          this.setState({
            fcc_integration_enabled: true,
            is_fcc_enabled: "Yes",
            has_fcc_filer_id: hasFilerIdFromDB,
            filer_id: client.fcc_filer_id || "",
            isApproved: client.isApproved === 1 ? 1 : 0,
            fcc_filing_url: client.fcc_filing_url || "",
            lastVerifiedFilerId: hasFilerIdFromDB ? client.fcc_filer_id : "",
            fccSuccess: hasFilerIdFromDB,
          });
        }
      }
    } catch (error) {
      console.error("Error fetching integrations:", error);
    }
  };

  loadRoleFieldSetting = async () => {
    try {
      const res = await getRoleFieldSetting(
        auth.getClientAccount(),
        auth.getClientToken()
      );
      this.setState({
        role_field_enabled:
          res && res.data && res.data.role_field_enabled ? true : false,
      });
    } catch (error) {
      this.setState({ role_field_enabled: false });
    }
  };

  defaultChecks = async () => {
    let apiData = await getAccountData(
      auth.getClientAccount(),
      auth.getClientToken(),
    );
    // console.log("Agreement DATA: ", apiData.data);
    if (
      apiData.data.status === 403 ||
      apiData.data.errors === "authentication missing" ||
      apiData.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (
      apiData.data.status === 404 ||
      (apiData.data.data && apiData.data.data.length === 0)
    ) {
      // console.log("First 404 Error");
      //this.props.history.push("/error");
    } else if (apiData.data.status === 200 && apiData.data.data.length > 0) {
      localStorage.setItem(
        "client_sso_handshake",
        apiData.data.sso_handshake || "No",
      );

      this.props.addSettings(apiData.data.resellers_setting);
      this.props.addMsaInfo(apiData.data.agreement);

      this.setState({
        // Role is a separate field from Title; prefill for the profile form.
        role: apiData.data.data[0]["role"] || "",
        address: apiData.data.data[0]["address"],
        city: apiData.data.data[0]["city"],
        states: apiData.data.data[0]["state"],
        zip: apiData.data.data[0]["zip"],
        address2: apiData.data.data[0]["address2"],
        country: apiData.data.data[0]["country"],
        routingUrl: apiData.data.url,
      });
      if (apiData.data.agreement === "No") {
        this.setState({
          is_msa_signed: false,
          defaultLoader: false,
        });
      } else if (apiData.data.agreement === "Yes") {
        this.setState({
          is_msa_signed: true,
          defaultLoader: false,
        });
      }
    } else if (
      (apiData.data.status === 200 &&
        apiData.data.data[0]["isVerified"] === "No") ||
      apiData.data.data[0]["account_status"] !== "active"
    ) {
      auth.clientLogout();
    } else {
      // console.log("Last Error");
      //this.props.history.push("/error");
    }
  };

  pageView = () => {
    const { leftClientMenuItems } = this.props;

    if (!this.state.leftMenuLoaded) {
      // return <DashboardLoader />;
      return null;
    }

    let urlFromParams = window.location.pathname;
    let urlSegments = urlFromParams.split("/");

    urlSegments = urlSegments.slice(1);

    if (urlSegments[0] !== "client") {
      urlSegments = urlSegments.slice(1);
    }

    const firstPart = urlSegments.slice(0, 2).join("/");
    //console.log("URL segments:", urlSegments);
    //console.log("First part of URL:", firstPart);

    const matchedMenuItem = leftClientMenuItems.find((menuItem) => {
      const menuItemLink = menuItem.link.startsWith("/")
        ? menuItem.link.slice(1)
        : menuItem.link;

      const submenuLinks = menuItem.submenu.map((submenuItem) =>
        submenuItem.link.startsWith("/")
          ? submenuItem.link.slice(1)
          : submenuItem.link,
      );

      const menuItemLinkNormalized = `/${menuItemLink}`.toLowerCase();
      const firstPartNormalized = `/${firstPart}`.toLowerCase();

      if (
        menuItemLinkNormalized === firstPartNormalized ||
        submenuLinks.some(
          (submenuLink) =>
            `/${submenuLink}`.toLowerCase() === firstPartNormalized,
        )
      ) {
        return true;
      }

      return false;
    });

    const shouldRenderComponent = !!matchedMenuItem;

    if (shouldRenderComponent) {
      return this.renderComponent();
    }

    const mainPages = Object.keys(pageAssociations);
    for (const mainPage of mainPages) {
      if (pageAssociations[mainPage].includes(this.state.view)) {
        const mainPageMatched = leftClientMenuItems.find((menuItem) => {
          const menuItemLink = menuItem.link.startsWith("/")
            ? menuItem.link.slice(1)
            : menuItem.link;

          const submenuLinks = menuItem.submenu.map((submenuItem) =>
            submenuItem.link.startsWith("/")
              ? submenuItem.link.slice(1)
              : submenuItem.link,
          );

          const menuItemLinkNormalized = `/${menuItemLink}`.toLowerCase();
          const mainPageNormalized = `/client/${mainPage.toLowerCase()}`;

          if (
            menuItemLinkNormalized === mainPageNormalized ||
            submenuLinks.some(
              (submenuLink) =>
                `/${submenuLink}`.toLowerCase() === mainPageNormalized,
            )
          ) {
            return true;
          }

          return false;
        });

        if (mainPageMatched) {
          return this.renderComponent();
        }
      }
    }

    return <AccessDenied />;
  };

  renderComponent = () => {
    let shouldRenderServices = false;
    let shouldRenderOrders = false;
    let shouldRenderRfq = false;
    switch (this.state.view) {
      case "dashboard":
        shouldRenderServices = this.props.leftClientMenuItems.some(
          (menuItem) => {
            if (menuItem.link === "/client/services") {
              return true;
            } else if (menuItem.submenu && menuItem.submenu.length > 0) {
              return menuItem.submenu.some(
                (submenuItem) => submenuItem.link === "/client/services",
              );
            }
            return false;
          },
        );

        shouldRenderOrders = this.props.leftClientMenuItems.some((menuItem) => {
          if (menuItem.link === "/client/SalesOrders") {
            return true;
          } else if (menuItem.submenu && menuItem.submenu.length > 0) {
            return menuItem.submenu.some(
              (submenuItem) => submenuItem.link === "/client/SalesOrders",
            );
          }
          return false;
        });

        shouldRenderRfq = this.props.leftClientMenuItems.some((menuItem) => {
          if (menuItem.link === "/client/Rfqs") {
            return true;
          } else if (menuItem.submenu && menuItem.submenu.length > 0) {
            return menuItem.submenu.some(
              (submenuItem) => submenuItem.link === "/client/Rfqs",
            );
          }
          return false;
        });

        return (
          <Dashboard
            props={this.props}
            shouldRenderServices={shouldRenderServices}
            shouldRenderOrders={shouldRenderOrders}
            shouldRenderRfq={shouldRenderRfq}
          />
        );
      case "services":
        return <Services props={this.props} />;
      case "Pdfdownload":
        return <Pdfdownload props={this.props} />;
      case "UnsignedAgreements":
        return <UnsignedAgreements props={this.props} />;
      case "UnsignedAgreement":
        return <UnsignedAgreement props={this.props} />;
      case "SubClients":
        return <SubClients props={this.props} />;
      case "AddSubClient":
        return <AddSubClient props={this.props} />;
      case "help":
        return <Help props={this.props} />;
      case "MetabaseReports":
        return <MetabaseReports props={this.props} />;
      case "SBCSettings":
        return <SBCSettings props={this.props} />;
      case "requestReports":
        return <RequestReports props={this.props} />;
      case "editRequest":
        return <EditRequest props={this.props} />;
      case "viewRequest":
        return <ViewRequest props={this.props} />;
      case "KycForm":
        return <KycForm props={this.props} />;
      case "Rfqs":
        return <Rfqs props={this.props} />;
      case "AddRfq":
        return <AddRfq props={this.props} />;
      case "EditRfq":
        return <EditRfq props={this.props} />;
      case "Quotations":
        return <Quotations props={this.props} />;
      case "ViewQuotation":
        return <ViewQuotation props={this.props} />;
      case "SalesOrders":
        return <SalesOrders props={this.props} />;
      case "ViewSalesOrder":
        return <ViewSalesOrder props={this.props} />;
      case "EditSalesOrder":
        return <EditSalesOrder props={this.props} />;
      case "AccountActivity":
        return <AccountActivity props={this.props} />;
      case "BillingInformation":
        return <BillingInformation props={this.props} />;
      case "Invoices":
        return <Invoices props={this.props} />;
      case "PaymentHistory":
        return <PaymentHistory props={this.props} />;
      case "Pricing":
        return <Pricing props={this.props} />;
      case "Loaders":
        return <Loaders props={this.props} />;
      case "Cdr":
        return <Cdr props={this.props} />;
      case "SmsRecords":
        return <SmsRecords props={this.props} />;
      case "MouStats":
        return <MouStats props={this.props} />;
      case "BalanceUsage":
        return <BalanceUsage props={this.props} />;
      case "CreditApp":
        return <CreditApp props={this.props} />;
      case "AddCreditApp":
        return <AddCreditApp props={this.props} />;
      case "agreements":
        return <Agreements props={this.props} />;
      case "documents":
        return <ClientDocuments props={this.props} />;
      case "msa_signing":
        return <MSA />;
      case "forms":
        return <Forms props={this.props} />;
      case "client_form_submit":
        return <FormSubmit props={this.props} />;
      case "client_form_submissions":
        return <FormSubmissions props={this.props} />;
      case "client_form_submission_single":
        return <FormSubmissionSingle props={this.props} />;
      case "ApiKey":
        return <ApiKey props={this.props} />;
      // case "viewClientAnalytics":
      //   return <ViewClientAnalytics props={this.props} />;
      default:
        return <ErrorPage />;
    }
  };

  capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  pageChange = (data) => {
    this.props.history.push("/" + data);
  };

  profileView = () => {
    const savedFilerId = this.state.lastVerifiedFilerId || "";
    this.setState({
      successMessage: "",
      errorMessage: "",
      password: "",
      filer_id: savedFilerId,
      fccSuccess: savedFilerId !== "",
      errorFilerID: "",
    });
    window.$("#modalFormProfile").modal("show");
  };

  render() {
    const shouldShowAgreementWhileChecking =
      this.state.onboardingComplete && !this.state.mandatoryAgreementsStatusLoaded;
    const showStandaloneAgreement =
      this.state.onboardingComplete &&
      (this.state.hasPendingMandatoryAgreements ||
        shouldShowAgreementWhileChecking);
    const showSidebar = this.state.onboardingComplete && !showStandaloneAgreement;

    return (
      <div
        className={`nk-body bg-lighter npc-general ${showSidebar ? "has-sidebar" : ""}`}
      >
        <div className="nk-app-root">
          <div className="nk-main">
            {this.state.defaultLoader === true ? (
              <div>
                <div>
                  {showSidebar ? (
                    <LefeSideBar
                      mainProps={this.props}
                      menuArr={this.props.leftClientMenuItems}
                      routingUrl={this.state.routingUrl}
                      {...this.props}
                    />
                  ) : null}
                </div>
                {/*<div>
                  <DashboardLoader />
            </div>*/}
              </div>
            ) : (
              <div>
                {showSidebar ? (
                  <LefeSideBar
                    mainProps={this.props}
                    menuArr={this.props.leftClientMenuItems}
                    routingUrl={this.state.routingUrl}
                    {...this.props}
                    direct_sso={this.state.direct_sso}
                  />
                ) : null}
              </div>
            )}

            <div className="nk-wrap ">
              <Header
                isNdaSigned={this.state.is_msa_signed}
                modalOpen={() => {
                  this.profileView();
                }}
                mainProps={this.props}
                modalLogin={() => {
                  this.loginDetailView();
                }}
                modalContactAgent={() => {
                  this.contactAgent();
                }}
              />

              {/* Agreement is now the first step inside the Onboarding Stepper. Old standalone display disabled. */}
              {/* OLD STANDALONE AGREEMENT — commented out, do not delete
              !this.state.is_msa_signed ? (
                <Agreement
                  backgroundColor={this.state.bgColor}
                  vendor_signor_signature_file={
                    this.state.vendor_signor_signature_file
                  }
                  mainHistory={this.props}
                  agreementSigned={() => {
                    this.agreementSigned();
                    this.checkOnboardingStatus();
                  }}
                />
              ) : */}
              {!this.state.onboardingComplete ? (
                // Show Onboarding Stepper (Agreement Terms is step 0 inside it)
                <ClientboardingDashboard
                  {...this.props}
                  refreshStatus={this.checkOnboardingStatus}
                  parentComponent={this}
                  isClientOnboarding={true}
                />
              ) : showStandaloneAgreement ? (
                <div className="nk-content nk-content-fluid pt-0">
                  <div className="container-fluid">
                    <div className="nk-block mt-4">
                      <Agreement
                        backgroundColor={this.state.bgColor}
                        vendor_signor_signature_file={
                          this.state.vendor_signor_signature_file
                        }
                        mainHistory={this.props}
                        agreementSigned={() => {
                          this.agreementSigned();
                          this.checkOnboardingStatus();
                          this.refreshMandatoryAgreementsStatus();
                        }}
                      />
                    </div>
                  </div>
                </div>
              ) : (
                // Show main page when onboarding is complete
                this.pageView()
              )}
              {/* MODAL EDIT PROFILE START */}
              <div
                className="modal fade"
                tabIndex="-1"
                id="modalFormProfile"
                data-backdrop={this.state.is_redirect ? "static" : true} // Prevent closing by backdrop when redirect
                data-keyboard={this.state.is_redirect ? "false" : "true"} // Prevent closing with Esc key
              >
                <div className="modal-dialog modal-xl" role="document">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Edit Profile</h5>

                      {!this.state.is_redirect && ( // Show cross icon only if not redirect
                        <a
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          style={{ cursor: "pointer" }}
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                      )}
                    </div>

                    <div className="modal-body">
                      {/* Error Start */}
                      {this.state.errorMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-danger">
                            <div className="alert-text">
                              <h4>Error</h4>
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: this.state.errorMessage,
                                }}
                              ></p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      {this.state.successMessage !== "" ? (
                        <div className="example-alert">
                          <div className="alert alert-pro alert-success">
                            <div className="alert-text">
                              <h4>Success</h4>
                              <p>{this.state.successMessage}</p>
                            </div>
                          </div>
                        </div>
                      ) : null}
                      <br />

                      <div className="row g-4">
                        {this.state.fcc_integration_enabled && (
                          <>
                            <div className="col-lg-12">
                              <div className="form-group">
                                <div className="custom-control custom-checkbox">
                                  <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    id="has_fcc_filer_id"
                                    name="has_fcc_filer_id"
                                    checked={this.state.has_fcc_filer_id}
                                    onChange={(e) => {
                                      this.setState({
                                        has_fcc_filer_id: e.target.checked,
                                        errorFilerID: "",
                                      });
                                    }}
                                  />
                                  <label
                                    className="custom-control-label"
                                    htmlFor="has_fcc_filer_id"
                                  >
                                    I have{" "}
                                    <a
                                      href="https://apps.fcc.gov/cgb/form499/499a.cfm"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      style={{
                                        color: "rgb(101, 118, 255)",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      FCC 499 Filer ID
                                    </a>
                                  </label>
                                </div>
                              </div>
                            </div>
                            {this.state.fccAutoFilled && (
                              <div
                                className="col-lg-12"
                                style={{ marginBottom: "0px" }}
                              >
                                <div
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    padding: "6px 12px",
                                    backgroundColor: "#f0fdf4",
                                    border: "1px solid #bbf7d0",
                                    borderRadius: "6px",
                                    fontSize: "12px",
                                    color: "#166534",
                                  }}
                                >
                                  <em
                                    className="icon ni ni-info"
                                    style={{ fontSize: "14px" }}
                                  ></em>
                                  Some fields were auto-filled from Robocall
                                  Mitigation Database.
                                </div>
                              </div>
                            )}
                            {this.state.has_fcc_filer_id && (
                              <div className="col-12">
                                <div className="form-group">
                                  <label
                                    htmlFor="filer_id"
                                    style={{
                                      color: "black",
                                      fontWeight: "500",
                                      marginBottom: "8px",
                                    }}
                                  >
                                    499 Filer ID{" "}
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <FccFilerAutocomplete
                                    id="filer_id"
                                    name="filer_id"
                                    value={this.state.filer_id}
                                    className="form-control"
                                    placeholder="Search by Filer ID or Company Name"
                                    searchApi={this.searchFCCFilerClient}
                                    onSelect={this.handleFilerIdSelect}
                                    onInputChange={this.handleFilerIdInputChange}
                                    onBlur={this.handleFilerIdBlur}
                                    onEnterKey={() => this.handleFilerIdBlur()}
                                    disabled={this.state.fccLoading}
                                    style={{
                                      borderColor: this.state.errorFilerID
                                        ? "red"
                                        : this.state.fccSuccess
                                          ? "#17a479"
                                          : "initial",
                                      height: "45px",
                                      border: "1px solid #dbdfea",
                                      fontSize: "0.9375rem",
                                    }}
                                  />
                                  {this.state.fccLoading && (
                                    <small style={{ color: "#1ee0ac", fontSize: "12px", marginTop: "5px", display: "block" }}>
                                      Verifying Filer ID...
                                    </small>
                                  )}
                                  <div className="d-flex">
                                    {!this.state.fccLoading &&
                                      this.state.filer_id &&
                                      this.state.filer_id.trim() !== "" && (
                                        <>
                                          {this.state.fccSuccess ? (
                                            <small style={{ color: "#17a479", fontSize: "12px", marginTop: "5px", display: "block" }}>
                                              ✓ Filer ID verified successfully
                                              {this.state.isApproved === 1 &&
                                                this.state.filer_id.trim() === (this.state.lastVerifiedFilerId || "")
                                                ? " and Approved"
                                                : " and Pending Approval"}
                                            </small>
                                          ) : this.state.errorFilerID ? (
                                            <small style={{ color: "red", fontSize: "12px", marginTop: "5px", display: "block" }}>
                                              {this.state.errorFilerID}
                                            </small>
                                          ) : null}
                                        </>
                                      )}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {/* FCC Auto-fill notification badge */}
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label={`Company Name${this.isFieldRequired("client_company") ? " *" : ""}`}
                              error={this.state.errorCompName === "error"}
                              id="comp_name"
                              name="comp_name"
                              value={this.state.comp_name}
                              placeholder="Company Name"
                              onChange={this.handleChange}
                              type="text"
                              variant="outlined"
                              fullWidth
                              inputProps={{ maxLength: 100 }}
                              helperText="Allowed characters: (&nbsp; _ &nbsp; . &nbsp; -
                              &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; |
                              &nbsp; ! &nbsp; @ )"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label={`Full Name${this.isFieldRequired("name") ? " *" : ""}`}
                              error={this.state.errorName === "error"}
                              id="name"
                              name="name"
                              value={this.state.name}
                              placeholder="Full Name"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label={`Title${this.isFieldRequired("title") ? " *" : ""}`}
                              error={this.state.errorTitle === "error"}
                              id="title"
                              name="title"
                              value={this.state.title}
                              placeholder="Title"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Allowed characters: (&nbsp; _ &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                            />
                          </div>
                        </div>
                        {this.state.role_field_enabled ? (
                          <div className="col-lg-4">
                            <div className="form-group">
                              <MutextField
                                label="Role"
                                id="role"
                                name="role"
                                value={this.state.role}
                                placeholder="Role"
                                onChange={this.handleChange}
                                inputProps={{ maxLength: 30 }}
                                variant="outlined"
                                fullWidth
                              />
                            </div>
                          </div>
                        ) : null}
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label="Email"
                              type="text"
                              error={this.state.errorEmail === "error"}
                              id="email"
                              name="email"
                              value={this.state.email}
                              placeholder="Enter your email address"
                              onChange={this.handleChange}
                              disabled={true}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          {!this.state.isLoading && (
                            <ReactPhoneInput
                              country="us"
                              inputProps={{
                                name: "phone",
                                id: "phone",
                                maxLength: 20,
                                required: this.isFieldRequired("client_phone"),
                                label: "Phone Number",
                              }}
                              value={this.state.phone}
                              onChange={(value) =>
                                this.handleChange({
                                  target: {
                                    name: "phone",
                                    value: `+${value}`,
                                  },
                                })
                              }
                              specialLabel={`Phone Number${this.isFieldRequired("client_phone") ? " *" : ""}`}
                              containerStyle={{ width: "100%"}}
                              inputStyle={{ width: "100%", height: "56px" }}
                              isValid={this.state.errorPhone !== "error"}
                            />

                          )}
                        </div>
                        <div
                          id="profileUpdate"
                          className="col-lg-4"
                        >
                          <div className="nk-block-between-md g-4"
                            style={{
                              position: "absolute",
                              zIndex: 9999,
                              right: "13px",
                              top: "-15px",
                            }}
                          >
                            {this.state.address_autocomplete === "Yes" && (
                              <div className="nk-block-head-content">
                                <ul className="nk-block-tools gx-3">
                                  <li>
                                    <a
                                      onClick={this.handleToggle}
                                      className="text-primary fs-11"
                                      style={{
                                        cursor: "pointer",
                                        fontSize: "11px",
                                      }}
                                    >
                                      {this.state.toggleButtonText}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            )}
                          </div>
                          <div>
                            {this.state.address_autocomplete === "Yes" ? (
                              this.state.useGooglePlaces ? (
                                <GooglePlacesAutocomplete
                                  apiKey={
                                    process.env
                                      .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                                  }
                                  selectProps={{
                                    value: this.state.address
                                      ? {
                                        label: this.state.address,
                                        value: this.state.address,
                                      }
                                      : null,
                                    onChange: this.handleAddressSelect,
                                    placeholder: this.state.address
                                      ? null
                                      : "Enter your address..",
                                    styles: {
                                      input: (provided) => ({
                                        ...provided,
                                        color: "black",
                                      }),
                                      option: (provided) => ({
                                        ...provided,
                                        color: "black",
                                      }),
                                      singleValue: (provided) => ({
                                        ...provided,
                                        color: "black",
                                      }),
                                      menu: (provided) => ({
                                        ...provided,
                                        zIndex: 9,
                                      }),
                                    },
                                  }}
                                />
                              ) : (
                                <MutextField
                                  id="address"
                                  name="address"
                                  value={this.state.address}
                                  placeholder="Enter Po Box address *"
                                  onChange={this.handleChange}
                                  variant="outlined"
                                  fullWidth
                                  error={this.state.errorAddress === "error"}
                                  label="Po Box address *"
                                  InputLabelProps={{
                                    shrink: true,
                                    required: false,
                                  }}
                                  inputProps={{ maxLength: 100 }}
                                />
                              )
                            ) : (
                              // address_autocomplete === "No" → show PO Box only
                              <MutextField
                                id="address"
                                name="address"
                                type="text"
                                value={this.state.address}
                                placeholder="Enter your address"
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                                error={this.state.errorAddress === "error"}
                                label="Address *"
                                InputLabelProps={{
                                  shrink: true,
                                  required: false,
                                }}
                              />
                            )}
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label="Apartment, Suite, Etc."
                              type="text"
                              error={this.state.errorAddress2 === "error"}
                              id="address2"
                              name="address2"
                              value={this.state.address2}
                              placeholder="Apartment, Suite, Etc."
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <MutextField
                              label={`City${this.isFieldRequired("client_city") ? " *" : ""}`}
                              type="text"
                              error={this.state.errorCity === "error"}
                              id="city"
                              name="city"
                              value={this.state.city}
                              placeholder="Enter your city"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <MutextField
                              label={`State${this.isFieldRequired("client_state") ? " *" : ""}`}
                              type="text"
                              error={this.state.errorState === "error"}
                              id="states"
                              name="states"
                              value={this.state.states}
                              placeholder="Enter your state"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-2">
                          <div className="form-group">
                            <MutextField
                              label={`Zip Code${this.isFieldRequired("client_zip") ? " *" : ""}`}
                              type="text"
                              error={this.state.errorZip === "error"}
                              id="zip"
                              name="zip"
                              value={this.state.zip}
                              placeholder="Enter your zip code"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                            />
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div className="form-group">
                            <Autocomplete
                              options={this.countryOptions}
                              getOptionLabel={(option) => option.label}
                              value={
                                this.state.country
                                  ? this.countryOptions.find(
                                      (opt) =>
                                        opt.label === this.state.country ||
                                        opt.value === this.state.country,
                                    ) || null
                                  : null
                              }
                              onChange={(event, newValue) => this.handleChangeCountry(newValue)}
                              renderInput={(params) => (
                                <MutextField
                                  {...params}
                                  required={this.isFieldRequired("client_country")}
                                  placeholder="Select a country"
                                  variant="outlined"
                                  fullWidth
                                  label={`Country${this.isFieldRequired("client_country") ? " *" : ""}`}
                                  error={this.state.errorCountry === "error"}
                                  helperText="Select country"
                                />
                              )}
                            />
                          </div>
                        </div>
                        {/* Keep Password & Confirm Password side by side regardless of the
                            optional Role field shifting the grid. */}
                        <div className="w-100"></div>
                        <div className="col-lg-4">
                          <div
                            className="form-group"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              label="Password"
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              error={this.state.errorPass === "error"}
                              id="password"
                              name="password"
                              value={this.state.password}
                              placeholder="Enter your password"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Password must be at least 8 characters, with uppercase, lowercase, number & special character."
                              InputLabelProps={{ shrink: true }}
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "2px",
                                top: "30px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.togglePassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <div style={{marginTop: "10px"}}>
                              <PasswordStrengthBar
                                password={this.state.password}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4">
                          <div
                            className="form-group"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              label="Confirm Password"
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              error={this.state.errorPass === "error"}
                              id="confirm_password"
                              name="confirm_password"
                              value={this.state.confirm_password}
                              placeholder="Confirm Password"
                              onChange={this.handleChange}
                              variant="outlined"
                              fullWidth
                              helperText="Confirm Password must be at least 8 characters, with uppercase, lowercase, number & special character. Confirm Password must match the Password."
                              InputLabelProps={{ shrink: true }}
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "2px",
                                top: "30px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={() => {
                                this.toggleConfirmPassword();
                              }}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="comfirm-password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                          </div>
                        </div>
                        <div className="col-lg-4">&nbsp;</div>
                        <div style={{ clear: "both" }}></div>
                        {/* <div className="form-group">
                        <label className="form-label" htmlFor="password">
                          Password
                        </label>
                        <div className="form-control-wrap">
                          <a
                            tabIndex="-1"
                            href="#"
                            className="form-icon form-icon-right passcode-switch"
                            data-target="password"
                          >
                            <em className="passcode-icon icon-show icon ni ni-eye"></em>
                            <em className="passcode-icon icon-hide icon ni ni-eye-off"></em>
                          </a>
                          <input
                            type="password"
                            className={
                              "form-control form-control-lg " +
                              this.state.errorPass
                            }
                            id="password"
                            name="password"
                            value={this.state.password}
                            onChange={this.handleChange}
                            placeholder="Enter your password"
                          />
                        </div>
                      </div> */}
                        <div className="col-lg-12 text-right">
                          <button
                            type="button"
                            className="btn btn-lg"
                            onClick={() => {
                              this.formUpdate();
                            }}
                            style={{
                              backgroundColor: THEME_COLOR,
                              color: THEME_TEXT_COLOR,
                              float: "right",
                            }}
                            disabled={this.state.disabled}
                          >
                            Update Profile
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* END MODAL EDIT PROFILE */}
              {/* Alert Permission */}
              <div className="modal fade" tabIndex="-1" id="modalAlertPermission">
                <div className="modal-dialog" role="document">
                  <div className="modal-content">
                    <div className="modal-body modal-body-lg text-center">
                      <div className="nk-modal">
                        <em
                          className="icon ni ni-alert-circle"
                          style={{ fontSize: "3rem" }}
                        ></em>

                        <h4 className="nk-modal-title">No Permission</h4>
                        <div className="nk-modal-text">
                          <div className="caption-text">
                            You do not have permission to access the VoiceAlerts
                            dashboard. Please contact the administrator for
                            access.
                          </div>
                        </div>
                        <div className="nk-modal-action">
                          <a
                            style={{ cursor: "pointer", color: "#fff" }}
                            className="btn btn-lg btn-mw btn-secondary"
                            onClick={() => {
                              this.modalHideRemoveAlert("modalAlertPermission");
                            }}
                            disabled={this.state.disabled}
                          >
                            CLOSE
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Alert Permission */}
              {/* { MODAL LOGIN DETAILS } */}
              <div
                className="modal fade"
                id="modalLoginDetail"
                tabIndex="-1"
                role="dialog"
                aria-labelledby="modalLoginDetailLabel"
                aria-hidden="true"
              >
                <div
                  className="modal-dialog modal-xl modal-dialog-top"
                  role="document"
                >
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title" id="modalLoginDetailLabel">
                        Login Details
                      </h5>
                      <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        style={{
                          outline: "none",
                          boxShadow: "none",
                          border: "none",
                          backgroundColor: "transparent",
                        }}
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div className="modal-body">
                      {/* Table to Display Login Details */}
                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="thead-light">
                            <tr>
                              <th>IP Address</th>
                              <th>Country</th>
                              <th>State</th>
                              <th>City</th>
                              <th>Timezone</th>
                              <th>Login Time</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.loginDetails &&
                              this.state.loginDetails.length > 0 ? (
                              this.state.loginDetails.map((detail, index) => (
                                <tr key={index}>
                                  <td>{detail.ip_address}</td>
                                  <td>{detail.country}</td>
                                  <td>{detail.state}</td>
                                  <td>{detail.city}</td>
                                  <td>{detail.time_zone}</td>
                                  <td>
                                    {new Date(detail.login_time)
                                      .toLocaleDateString("en-US", {
                                        month: "long",
                                        day: "numeric",
                                        year: "numeric",
                                      })
                                      .replace(/(\d+)(?=,)/, "$1th")}
                                    ,{" "}
                                    {new Date(
                                      detail.login_time,
                                    ).toLocaleTimeString("en-US")}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="6" className="text-center">
                                  No login details found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* { MODAL LOGIN DETAILS } */}
              {/***  CONTACT AGENT  ***/}
              <div className="modal fade" tabIndex="-1" id="modalContactAgent">
                <div
                  className="modal-dialog modal-dialog-top modal-xl"
                  role="document"
                >
                  <div className="modal-content">
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                    <div className="modal-header">
                      <h5 className="modal-title">
                        <em className="icon ni ni-emails"></em> Contact Agent
                      </h5>
                    </div>
                    <div className="modal-body">
                      <h6>Agent Details</h6>
                      <div
                        className="card card-bordered"
                        id="creditApplicationTables"
                      >
                        <table className="table table-striped table-bordered">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Name</td>
                              <td>Sajid Riaz</td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Email</td>
                              <td></td>
                            </tr>
                            <tr>
                              <td style={{ fontWeight: "bold" }}>Phone</td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      <h6 className="pt-4 pb-4">Send Email</h6>
                      <div className="row g-4">
                        {this.state.errorMessageContactAgent !== "" ? (
                          <div className="col-md-12 mb-3">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessageContactAgent}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageContactAgent !== "" ? (
                          <div className="col-md-12 mb-3">
                            <div
                              className="example-alert example-alert-revoke"
                              style={{ marginBottom: "15px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessageContactAgent}</p>
                                </div>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="form-control-group">
                              <MutextField
                                required
                                id="contact_subject"
                                name="contact_subject"
                                type="text"
                                label="Subject"
                                defaultValue={this.state.contact_subject}
                                inputProps={{ maxLength: 64 }}
                                onInput={(e) => {
                                  e.target.value = e.target.value.replace(
                                    /[^a-zA-Z0-9 ]/gi,
                                    "",
                                  );
                                }}
                                helperText="Enter the subject here."
                                onChange={this.handleChange}
                                variant="outlined"
                                fullWidth
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="form-group">
                            <div className="form-control-group">
                              <TextareaAutosize
                                maxRows={4}
                                name="contact_comment"
                                id="contact_comment"
                                aria-label=""
                                placeholder="Add Comment *"
                                maxLength={500}
                                value={this.state.contact_comment}
                                onChange={this.handleChange}
                                style={{
                                  width: "100%",
                                  height: "100px",
                                  borderColor: "rgba(0, 0, 0, 0.125)",
                                  borderRadius: "4px",
                                  padding: "5px",
                                }}
                                variant="outlined"
                              />
                            </div>
                          </div>
                        </div>

                        <div className="col-md-12">
                          <div className="example-alert">
                            <div className="alert alert-light">
                              <ul className="list">
                                <li>
                                  An email will be sent to your assigned agent's
                                  email address, including the subject and
                                  comment.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer text-right d-flex justify-content-end">
                      <a
                        href="#"
                        className="btn btn-mw btn-light"
                        data-dismiss="modal"
                      >
                        Close
                      </a>
                      <button
                        type="button"
                        onClick={() => this.contactAgentSubmit()}
                        className="btn btn-primary"
                        disabled={this.state.disabled}
                      >
                        <span>Send Email</span>{" "}
                        <em className="icon ni ni-emails"></em>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              {/***  CONTACT AGENT  ***/}
              <Footer />
              {this.state.showClientAgentPopup &&
                this.state.conversational_ai_integration &&
                this.state.has_ai_url &&
                this.state.activeAgentId && (
                  <LiveKitPopup
                    agentId={this.state.activeAgentId}
                    agentRoom={this.state.activeAgentRoom}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state,
    leftClientMenuItems: state.leftClientMenuItems,
    quotationSettings: state.quotationSettings,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
    addMsaInfo: (payload) => dispatch(addMsaInfo(payload)),
    setClientLeftMenu: (menuClientItems) =>
      dispatch(setClientLeftMenu(menuClientItems)),
    setQuotationSettings: (quotationsettings) =>
      dispatch(setQuotationSettings(quotationsettings)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);
